import React, { useState, useEffect, memo } from 'react'
import { useSelector } from 'react-redux'
import axios from 'axios'
import { makeStyles } from '@material-ui/core/styles'
import { Typography, Box, Grid, Chip } from '@material-ui/core'

import _, { get } from 'lodash'
import { Route, Redirect } from 'react-router-dom'

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {ServerConfig} from 'config'
import EditComponent from '../EntryListAndEdit/EditComponent.js'
import AddComponent from '../EntryListAndEdit/AddComponent.js'

const useStyles = makeStyles((theme) => ({
  serviceChip: {
    color: "white",
    fontWeight: "bold",
    textTransform: "uppercase",
    marginRight: 4,
    marginBottom: 4,
    fontSize: "11px",
    height: 24,
    letterSpacing: "0.3px",
  },
  alt1: {
    backgroundColor: theme.palette.secondary.alt1,
  },
  alt2: {
    backgroundColor: theme.palette.secondary.alt2,
  },
  alt3: {
    backgroundColor: theme.palette.secondary.alt3,
  },
  alt4: {
    backgroundColor: theme.palette.secondary.alt4,
  },
  alt5: {
    backgroundColor: theme.palette.secondary.alt5,
  },
}))

const NonPaginatedList = (props) => {
  const classes = useStyles()

  const auth = useSelector(state => state.auth)
  const [entries, setEntries] = useState([])
  const [total, setTotal] = useState(0)
  const [searchterm, setSearchterm] = useState("")

  // create state-dict for filters
  let initial_filter_values = {}
  for(var i in props.filter_inputs){
    initial_filter_values[props.filter_inputs[i]['name']] = {'type': props.filter_inputs[i]['type'], 'value':props.filter_inputs[i]['initial_value']};
  }
  const [filterValues, setFilterValues] = useState(initial_filter_values);

  const [column_names, setColumnNames] = useState(props.column_names)
  const [header_names, setHeaderNames] = useState(props.header_names)

  /* check and update number of columns depending on screen-size */
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  let list_get_url = props.list_get_url;
  let detail_get_url = props.detail_get_url;
  let detail_put_url = props.detail_put_url;
  let detail_delete_url = props.detail_delete_url;
  let detail_delete_method = props.detail_delete_method;
  let ledger_get_url = props.ledger_get_url;
  let ledger_insert_url = props.ledger_insert_url;
  let add_new_url = props.add_new_url;
  let ledger_allow_entries = props.ledger_allow_entries;
  let show_machine_stats = props.show_machine_stats;

  let editable_fields = props.editable_fields;
  let non_editable_fields = props.non_editable_fields;

  useEffect(() => {
    const fetchListData = async () => {
      const config = { headers: { 'Content-Type': 'application/json' } }

      if (auth.access_token) {
        config.headers.Authorization = `Bearer ${auth.access_token}`
      }

      var mydict = {};
      for (const [key, value] of Object.entries(filterValues)) {
        if(value["type"] == "date"){
          let thisval = value["value"];
          mydict[key] = (1900+thisval.getYear())+"-"+(1+thisval.getMonth())+"-"+(thisval.getDate())
        }else{
          mydict[key] = value["value"];
        }
      }

      const results = await axios.post(list_get_url, mydict, config)  // try with ledger-url

      setTotal(results.data.length)

      results.data = results.data.map((row, rowIdx) => {
        if (Array.isArray(row.services) && row.services.length) {
          row.services = row.active_services?.map(({id, name, color}, idx) => {
            return (
              <Chip
                key={`${row.id || rowIdx}-${id}-${idx}`}
                label={name}
                className={`${classes[color]} ${classes.serviceChip}`}
              />
            );
          });
        }
        return row;
      });

      let processed_data = []

      if(searchterm !== ''){
        for (var i in results.data) {
          for (const [key, value] of Object.entries(results.data[i])) {
            let value = String(results.data[i][key]);
            if (value.toLowerCase().search(searchterm.toLowerCase()) != -1){ // found
              processed_data.push(results.data[i]);
              break;
            }
          }
        }
      }else{
        processed_data = results.data;
      }

      for (var i in processed_data) {
        for (const [key, value] of Object.entries(processed_data[i])) {
          if (key == 'balance' || key == 'donated' || key == 'earned redemption' || key == 'withdrawn') {
            processed_data[i][key] = '$' + (processed_data[i][key] / 1e6);
          }
          console.log(key, value);
        }
      }

      setEntries(processed_data)
    }

    fetchListData();

    window.addEventListener('customertable_is_dirty', fetchListData);
  }, [searchterm, filterValues])

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if(screenSize.width > 1080){
      // if a value was in column_names AND is in the optional_columns list, remove it form the first
      let new_column_names = [];
      let new_header_names = [];

      for(var i in props.column_names){
        if(!props.optional_column_names.includes(props.column_names[i])){
          new_column_names.push(props.column_names[i]);
          new_header_names.push(props.header_names[i]);
        }
      }

      setColumnNames(new_column_names.concat(props.optional_column_names));
      setHeaderNames(new_header_names.concat(props.optional_header_names));
    }else{
      setColumnNames(props.column_names);
      setHeaderNames(props.header_names);
    }
  }, [screenSize.width])

  const onChangeSearchterm = (event) => {
    setSearchterm(event.target.value)
  };

  if (!auth.access_token) {
    return <Redirect to="/login" />
  }

  function updateFilterValues(datatype, name, value){
    console.log("Updating value "+name+" to value "+value);
    let copyFoo = { ...filterValues }; //create a new copy and change the value of bar
    copyFoo[name]['value'] = value
    setFilterValues(copyFoo)//write it back to state
    //setFilterValues(...filterValues, filterValues[name]: value);
  }

  function createFilterInputs(){
    return(
      <Grid container>
        {_.map(props.filter_inputs, (data, key) => {
          if(data['type'] == 'date'){
            return(
              <Grid xs={12} sm={3} style={{'marginBottom': '20px'}}>
                <Typography variant="h2">
                  {data['label']}
                </Typography>
                <DatePicker
                  selected={filterValues[data['name']]['value']}
                  onChange={(value) => {updateFilterValues(data['type'], data['name'], value)}}
                  dateFormat="MMMM d, yyyy"
                  className="form-select" />
              </Grid>
            )
          }else if(data['type'] == 'timezone'){
            return(
              <Grid xs={12} sm={3} style={{'margin-bottom': '20px', 'padding-right':'20px'}}>
                <Typography variant="h2">
                  Timezone
                </Typography>
                <select
                  className="form-select"
                  onChange={(event) => {updateFilterValues(data['type'], data['name'], event.target.value)}}>
                    <option value="America/New_York">New York</option>
                    <option value="America/Los_Angeles">California</option>
                  </select>
              </Grid>
            )
          }else{
            return(
              <Grid xs={12}>{data['name']}</Grid>
            )
          }
          })
        }
      </Grid>
    )
  }


  function createSearchBox(){
    return(
        <Grid container>
          <Grid sm={12} md={8}>{total} results</Grid>
          <Grid sm={12} md={4}>
            <label htmlFor="searchterm" style={{'display':'inline-block', 'marginRight':'5px'}}>Search</label>
            <input type="text" name="searchterm" id="searchterm" defaultValue="" onChange={onChangeSearchterm} />
          </Grid>
        </Grid>
        )
  }

  return(<>
    {createFilterInputs()}
    {createSearchBox()}

    <table class='table table-striped' style={{'width':'100%'}}>
    <thead>
      <tr>
      {_.map(header_names, hn => {
          return <th style={{'padding':'10px'}}>{hn}</th>
      })}

    {detail_get_url !== undefined &&
        <th style={{'textAlign': 'right'}}>Edit</th>
    }
        </tr>
        </thead>

        <tbody>
        {_.map(entries, entry => {
            return <tr>
                {_.map(column_names, cn => {
                  let converted_value;

                  if (cn.includes('microdollar') || cn.includes('balance')) {
                    let USDollar = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD',});
                    converted_value = USDollar.format((entry[cn] / 1e6).toFixed(2));
                  } else if (cn == "timestamp" || cn == "start_utc_timestamp" || cn == "end_utc_timestamp" || cn == "ts_created") {
                    let thisdate = new Date(entry[cn])
                    converted_value = thisdate.toLocaleDateString("en-US") + " " + thisdate.toLocaleTimeString("en-US");
                  }else if (typeof(entry[cn]) === "boolean"){
                    converted_value = entry[cn].toString();
                  }else{
                    converted_value = entry[cn];
                  }
                    return <td style={{'padding':'10px'}}>{converted_value}</td>
                })}

        {detail_get_url !== undefined &&
                  <EditComponent
                    detail_get_url={detail_get_url}
                    detail_put_url={detail_put_url}
                    detail_delete_url={detail_delete_url}
                    detail_delete_method={detail_delete_method}
                    rowData={entry}
                    editable_fields={editable_fields}
                    non_editable_fields={non_editable_fields}
                    ledger_get_url={ledger_get_url}
                    ledger_insert_url={ledger_insert_url}
                    ledger_allow_entries={ledger_allow_entries}
                    show_machine_stats={show_machine_stats}
                  />
      }
            </tr>
        })
    }
    </tbody>
    </table>

    {add_new_url !== undefined &&
      <AddComponent
          add_new_url={add_new_url}
          editable_fields={editable_fields}
        />
    }

  </>)
}

export default NonPaginatedList